
import React from "react";

interface ConfettiCelebrationProps {
  trigger: boolean;
  duration?: number;
}

export function ConfettiCelebration({ trigger, duration = 2000 }: ConfettiCelebrationProps) {
  const [show, setShow] = React.useState(false);

  React.useEffect(() => {
    if (trigger) {
      setShow(true);
      const t = setTimeout(() => setShow(false), duration);
      return () => clearTimeout(t);
    }
  }, [trigger, duration]);

  if (!show) return null;

  // Simple emoji-based confetti overlay; can be upgraded to a canvas confetti
  return (
    <div className="absolute inset-0 flex justify-center items-center pointer-events-none z-30 select-none animate-fade-in">
      <span style={{ fontSize: 48, userSelect: "none" }}>🎉🎊🥳</span>
    </div>
  );
}
